export default __webpack_public_path__ + "static/media/promo.b15b9411.mp3";